import APIBaseService from "./APIBase";
import { HTTP_METHOD } from "./APIBase.d";

class AdminService extends APIBaseService {
  // authClient = new AuthService();
  // userService = new UserService();
  endpoint = "admin";

  getUserCPF = async (
    username?: string,
    groupID?: string | null
  ): Promise<any> => {
    // const res = await this.call(`${username}/${groupID}/getGroupDetails/${groupID}`, HTTP_METHOD.GET, null);
    try {
      const res = await this.call(
        `${username}/${groupID}/getGroupDetails/${groupID}`,
        HTTP_METHOD.GET,
        null
      );
      if (res !== undefined) {
        return res.data;
      } else {
        console.log("error");
        return {};
      }
    } catch (error: any) {
      throw new Error(error.message);
    }
  };
}

export default AdminService;
